module.exports = ''
+ '<div id="creek-content-page-container">'
+ '  <div v-if="!html">'+Creek.data.router.loadingHtml+'</div>'
+ '  <div v-if="html" v-html="html"></div>'
+ '</div>'


// WEBPACK FOOTER //
// ./src/templates/page-content-default.js